module.exports = __webpack_public_path__ + "img/argentina-logo-icon.9ee0bf10.png";